import React from 'react';
import { XCircle } from 'lucide-react';
import { Card } from '../ui/Card';
export function ProblemSection() {
  const problems = [{
    title: 'Inconsistent Sales',
    description: "You're posting content consistently, but your sales notifications are sporadic at best."
  }, {
    title: 'Weak Ad Performance',
    description: "Your ads are getting clicks, but the landing page isn't converting that traffic into buyers."
  }, {
    title: 'Launch Disappointments',
    description: "You have a large audience, but your launch revenue doesn't reflect your follower count."
  }, {
    title: 'Leaky Email Funnel',
    description: 'Your welcome sequence is gathering dust instead of nurturing leads into loyal customers.'
  }];
  return <section id="problem" className="py-24 bg-white" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-124">
          <div data-id="element-125">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-126">
              You've built a decent audience. <br data-id="element-127" />
              <span className="text-slate-400" data-id="element-128">
                But are you building the bank account?
              </span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-129">
              Most coaches are excellent at what they do but struggle to
              articulate their value in a way that makes people buy. You don't
              have a traffic problem. You have a conversion problem.
            </p>
            <div className="space-y-6" data-id="element-130">
              {problems.map((problem, index) => <div key={index} className="flex items-start" data-id="element-131">
                  <div className="flex-shrink-0 mt-1" data-id="element-132">
                    <XCircle className="w-6 h-6 text-red-500" data-id="element-133" />
                  </div>
                  <div className="ml-4" data-id="element-134">
                    <h3 className="text-lg font-semibold text-slate-900" data-id="element-135">
                      {problem.title}
                    </h3>
                    <p className="text-slate-600" data-id="element-136">{problem.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-137">
            <div className="absolute -inset-4 bg-slate-100 rounded-2xl transform rotate-2" data-id="element-138"></div>
            <Card className="relative bg-slate-900 text-white p-8 md:p-12 transform -rotate-1 border-none" data-id="element-139">
              <h3 className="text-2xl font-bold mb-6 text-emerald-400" data-id="element-140">
                The "Generic Copy" Trap
              </h3>
              <p className="text-slate-300 mb-6 text-lg" data-id="element-141">
                "I'm passionate about helping you unlock your potential."
              </p>
              <p className="text-slate-300 mb-8 text-lg" data-id="element-142">
                Sound familiar? This is why your prospects are scrolling past.
                Generic promises get generic results. To scale, you need
                messaging that cuts through the noise and speaks directly to
                your prospect's wallet.
              </p>
              <div className="h-px w-full bg-slate-700 mb-6" data-id="element-143"></div>
              <p className="font-medium text-white" data-id="element-144">
                Stop sounding like everyone else. Start sounding like the expert
                you are.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}